import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";

export default function TileCard({ item }) {
  const handleClick = () => {
    if (item.url) {
      window.open(item.url, item.target || "_blank");
    }
  };

  return (
    <Card
      onClick={handleClick}
      sx={{
        cursor: "pointer",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        transition: "all 0.2s ease",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: 4,
        },
      }}
    >
      <CardContent sx={{ flexGrow: 1, p: 2 }}>
        <Box sx={{ mb: 1, textAlign: "center" }}>
          <Typography variant="h6" component="div" sx={{ fontWeight: 600, fontSize: 14 }}>
            {item.icon || "📄"}
          </Typography>
        </Box>
        <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5, fontSize: 13 }}>
          {item.title}
        </Typography>
        {item.description && (
          <Typography variant="caption" color="text.secondary" sx={{ fontSize: 11 }}>
            {item.description}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
}
